module.exports = __webpack_public_path__ + "static/media/SELF.4b6ef0d3.pdf";